import { addLocaleData } from 'react-intl';
import enLang from './entries/en-US';
import esLang from './entries/es-ES';
import enRtlLang from './entries/en-US-rtl';
import chLang from './entries/zh-ZH';
import frLang from './entries/fr-FR';
import twLang from './entries/zh-HK';
import miLang from './entries/mi-MI';
import idLang from './entries/id-ID';
import tlLang from './entries/tl-TL';
import viLang from './entries/vi-VI';
import koLang from './entries/ko-KO';
import PTLang from './entries/pt-PT';
const AppLocale = {
  en: enLang,
  es: esLang,
  enrtl: enRtlLang,
  zh: chLang,
  fr: frLang,
  hk: twLang,
  mi: miLang,
  id: idLang,
  tl: tlLang,
  vi: viLang,
  ko: koLang,
  pt: PTLang
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.es.data);
addLocaleData(AppLocale.enrtl.data);
addLocaleData(AppLocale.zh.data);
addLocaleData(AppLocale.fr.data);
addLocaleData(AppLocale.hk.data);
addLocaleData(AppLocale.mi.data);
addLocaleData(AppLocale.id.data);
addLocaleData(AppLocale.tl.data);
addLocaleData(AppLocale.vi.data);
addLocaleData(AppLocale.ko.data);
addLocaleData(AppLocale.pt.data);
export default AppLocale;
